import { useState } from "react";

import { useCyclingOrder } from "../../components";
import { UiRotatingItemsModel } from "../../models";
import { renderViewModel, renderViewModels } from "../../render-view-model";

import { Container, RotatingItem } from "./UiRotatingItems.styles";

export type UiRotatingItemsProps = {
    model: UiRotatingItemsModel;
};

const UiRotatingItems = ({ model }: UiRotatingItemsProps) => {
    const [updatedAt, setUpdatedAt] = useState(0);
    /**
     * initialized with reverse order because stacked grid
     * displays last item on top
     */
    const items = useCyclingOrder(
        [...model.content.items].reverse(),
        updatedAt,
        true
    );
    const onAnimationEnd = () => {
        setUpdatedAt(Date.now());
    };
    const displayDuration = 5000;
    const transitionDuration = 1000;

    if (items.length < 2) {
        return <>{renderViewModels(items)}</>;
    }

    return (
        <Container>
            {items.map((item, index) => (
                <RotatingItem
                    key={item.id}
                    hasAnimation={index === items.length - 1}
                    displayDuration={displayDuration}
                    transistionDuration={transitionDuration}
                    onAnimationEnd={onAnimationEnd}
                >
                    {renderViewModel(item)}
                </RotatingItem>
            ))}
        </Container>
    );
};

export default UiRotatingItems;
